<template>
  <div>









      <CRow>
          <CCol md="9">



              <CCard class="center-div">




                  <b-row class="mt-2">




                              <b-col md="12" class="">

                                  <b-col md="12" class="bg-white ml-1" style="border-bottom: 4px solid #eee">




                                      <addIssue  :parent_id="addIssue.parent_id"
                                                 :reply_id="addIssue.reply_id"
                                                 :section_id="addIssue.section_id"

                                             >
                                      </addIssue>


<!--                                      :processes="processes"-->
<!--                                      :steps="steps"-->
<!--                                      :orders="orders"-->
<!--                                      :contacts="contacts"-->
<!--                                      :projects="projects"-->

                                  </b-col>
                              </b-col>






                  </b-row>

              </CCard>



              <div>




                  <b-row class="">


                      <b-col md="12">
                          <b-row class="">




                              <b-col md="12">








                                  <div>

                                      <ul class="tree">

                                          <li  v-for="(issue, issueIndex) in issues" :key="issueIndex" style="z-index: 3">

                                              <div class="sticky">

                                                  <b-row  data-toggle="collapse" :data-target="'#collapse-'+issue.id" aria-expanded="false" :aria-controls="'#collapse-'+issue.id"
                                                          style="border-top: 2px solid #9e9e9e;padding: 15px;background-color: #fff" :style="{borderTop: headerStyles(issue)}">



                                                      <b-col md="2" cols="3" class="my-1">
                                                          <b-badge  v-if="issue.board" pill variant="info" class="text-right p-1" style="float: right"
                                                                    :style="{backgroundColor: boardColor(issue.board.id)}">
                                                              {{issue.board.title}}
                                                          </b-badge>

                                                      </b-col>

                                                      <b-col  md="10" cols="9" class="my-1"  style="min-width: 200px">
                                                          <h6 v-if="issue.title && issue.title != 'null' && issue.title != '0'">{{issue.title}}</h6>



                                                      </b-col>

<!--                                                      <b-col  md="2" cols="3" class="my-1" >-->


<!--                                                          <b-badge v-if="issue.priority == 3"  pill class="text-right " size="sm" style="background-color: #212121;border: 1px solid #880e4f;float: right;font-size: 10px">اولویت زیاد</b-badge>-->
<!--                                                          <b-badge v-else-if="issue.priority == 2"   pill class="text-right " size="sm" style="background-color: #757575;float: right;font-size: 10px">اولویت متوسط</b-badge>-->
<!--                                                          <b-badge v-else-if="issue.priority == 1"  pill  class="text-right " size="sm" style="background-color: #9e9e9e;float: right;font-size: 10px">اولویت کم</b-badge>-->



<!--                                                      </b-col>-->

<!--                                                      <b-col  md="6" cols="5" class="my-1" >-->



<!--                                          <span v-if="issue.contact_id && issue.contact" :id="'tooltip-target-'+issue.id"-->
<!--                                                style="cursor: pointer" class="text-success  ml-2" >-->
<!--                                              <i class="fas fa-address-book"></i>-->
<!--                                          </span>-->
<!--                                                          <b-tooltip   placement="bottom" v-if="issue.contact_id && issue.contact" :target="'tooltip-target-'+issue.id" triggers="hover">-->
<!--                                                              <small>مشتری: </small>-->
<!--                                                              {{issue.contact.last_name}}-->
<!--                                                          </b-tooltip>-->






<!--                                                          <span v-if="issue.project_id && issue.project" :id="'tooltip-target-project-'+issue.id"-->
<!--                                                                style="cursor: pointer" class="text-info ml-2" >-->
<!--                                              <i class="fas fa-handshake"></i>-->
<!--                                          </span>-->
<!--                                                          <b-tooltip  placement="bottom" v-if="issue.project_id && issue.project" :target="'tooltip-target-project-'+issue.id" triggers="hover">-->
<!--                                                              <small>پروژه: </small>-->
<!--                                                              {{issue.project.title}}-->
<!--                                                          </b-tooltip>-->




<!--                                                          <span v-for="(step, stepIconIndex) in steps" v-if="step.id === issue.step_id" :key="stepIconIndex" :id="'tooltip-target-step-'+issue.id"-->
<!--                                                                style="cursor: pointer" class="text-dark ml-2" >-->
<!--                                              <i class="fas fa-random"></i>-->
<!--                                          </span>-->
<!--                                                          <b-tooltip v-for="(step, stepTooltipIndex) in steps" v-if="step.id === issue.step_id"  :key="stepTooltipIndex"   placement="bottom"  :target="'tooltip-target-step-'+issue.id" triggers="hover">-->
<!--                                                              <small>مرحله: </small>-->
<!--                                                              {{step.title}}-->
<!--                                                          </b-tooltip>-->





<!--                                                          <span  :id="'tooltip-target-created-'+issue.id"-->
<!--                                                                 style="cursor: pointer" class="text-secondary  ml-2" >-->
<!--                                              <i class="fas fa-calendar"></i>-->
<!--                                          </span>-->
<!--                                                          <b-tooltip   placement="bottom"  :target="'tooltip-target-created-'+issue.id" triggers="hover">-->
<!--                                                              <small>تاریخ ثبت: </small>-->
<!--                                                              {{issue.created_at| moment("dddd, jD jMMMM") }}-->
<!--                                                          </b-tooltip>-->





<!--                                                      </b-col>-->

<!--                                                      <b-col  md="4" cols="4"  class="my-1 text-left text-sm"  >-->
<!--                                                          &lt;!&ndash;                                          <small>&ndash;&gt;-->
<!--                                                          &lt;!&ndash;                                              <b-col md="12" class="text-left text-sm">&ndash;&gt;-->
<!--                                                          &lt;!&ndash;                                                  <small>&ndash;&gt;-->

<!--                                                          &lt;!&ndash;                                                      <router-link  v-if="issue.contact_id && issue.contact" :title="issue.contact.first_name +' '+issue.contact.last_name" :to="{path: '/contact/profile/'+issue.contact_id, params: {id: issue.contact_id}}"&ndash;&gt;-->
<!--                                                          &lt;!&ndash;                                                                   class="btn btn-success btn-sm" size="sm">&ndash;&gt;-->
<!--                                                          &lt;!&ndash;                                                          مشتری:&ndash;&gt;-->

<!--                                                          &lt;!&ndash;                                                          {{issue.contact.last_name}}&ndash;&gt;-->
<!--                                                          &lt;!&ndash;                                                      </router-link>&ndash;&gt;-->

<!--                                                          &lt;!&ndash;                                                  </small>&ndash;&gt;-->
<!--                                                          &lt;!&ndash;                                              </b-col>                                          </small>&ndash;&gt;-->



<!--                                                          &lt;!&ndash;                                          <b-badge  v-if="issue.contact_id && issue.contact" size="sm" variant="success"   class=" m-1" >&ndash;&gt;-->
<!--                                                          &lt;!&ndash;                                              <small>مشتری: </small>&ndash;&gt;-->
<!--                                                          &lt;!&ndash;                                              {{issue.contact.last_name}}</b-badge>&ndash;&gt;-->


<!--                                                          &lt;!&ndash;                                          <b-badge v-if="issue.project" size="sm" variant="info"   class=" m-1">&ndash;&gt;-->
<!--                                                          &lt;!&ndash;                                              <small>پروژه: </small>&ndash;&gt;-->
<!--                                                          &lt;!&ndash;                                              {{issue.project.title}}</b-badge>&ndash;&gt;-->




<!--                                                          &lt;!&ndash;                                          <span  v-for="(step, stepIndex) in steps" :key="stepIndex" >&ndash;&gt;-->
<!--                                                          &lt;!&ndash;&lt;!&ndash;                                                     <i v-if="stepIndex != 0" class="fa fa-arrow-left"></i>&ndash;&gt;&ndash;&gt;-->
<!--                                                          &lt;!&ndash;                                                    <b-badge  v-if="step.id === issue.step_id" variant="light">{{step.title}}</b-badge>&ndash;&gt;-->
<!--                                                          &lt;!&ndash;                                              &lt;!&ndash;                                                    <b-badge v-else variant="secondary" style="opacity: 30%!important;">{{step.title}}</b-badge>&ndash;&gt;&ndash;&gt;-->
<!--                                                          &lt;!&ndash;                                                </span>&ndash;&gt;-->





<!--                                                          <small class="text-color-blue mt-1 mr-2" >-->

<!--                                                              <span v-if="issue.type == 'lead'" class="badge badge-secondary pt-1" :style="{backgroundColor: typeBadgeStyles(issue)}">سرنخ/فرصت (Lead)</span>-->
<!--                                                              <span v-if="issue.type == 'meeting'" class="badge badge-secondary pt-1" :style="{backgroundColor: typeBadgeStyles(issue)}">ملاقات/جلسه/رویداد</span>-->
<!--                                                              <span v-if="issue.type == 'ticket'" class="badge badge-secondary pt-1" :style="{backgroundColor: typeBadgeStyles(issue)}">پیگیری (Ticket)</span>-->
<!--                                                              <span v-if="issue.type == 'bug'" class="badge badge-danger pt-1" :style="{backgroundColor: typeBadgeStyles(issue)}">ایراد (Bug)</span>-->
<!--                                                              <span v-if="issue.type == 'task'" class="badge badge-success pt-1" :style="{backgroundColor: typeBadgeStyles(issue)}">فعالیت (Task)</span>-->
<!--                                                              <span v-if="issue.type == 'epic'" class="badge badge-info pt-1" :style="{backgroundColor: typeBadgeStyles(issue)}">نسخه/فیچر (Epic)</span>-->
<!--                                                              <span v-if="issue.type == 'story'" class="badge badge-info pt-1" :style="{backgroundColor: typeBadgeStyles(issue)}">لیست (User Story)</span>-->


<!--                                                          </small>-->
<!--                                                      </b-col>-->



                                                  </b-row>




                                              </div>
                                              <ul>

                                                  <li v-for="(issue, issueIndex) in issue.issues" :key="issueIndex" style="right: 340px;z-index: 1">
                                                      <div class="sticky">
                                                          <b-row  data-toggle="collapse" :data-target="'#collapse-'+issue.id" aria-expanded="false" :aria-controls="'#collapse-'+issue.id"
                                                                  style="border-top: 2px solid #9e9e9e;padding: 15px;background-color: #fff" :style="{borderTop: headerStyles(issue)}">



                                                              <b-col md="2" cols="3" class="my-1">
                                                                  <b-badge  v-if="issue.board" pill variant="info" class="text-right p-1" style="float: right"
                                                                            :style="{backgroundColor: boardColor(issue.board.id)}">
                                                                      {{issue.board.title}}
                                                                  </b-badge>

                                                              </b-col>

                                                              <b-col  md="10" cols="9" class="my-1"  style="min-width: 200px">
                                                                  <h6 v-if="issue.title && issue.title != 'null' && issue.title != '0'">{{issue.title}}</h6>



                                                              </b-col>

<!--                                                              <b-col  md="2" cols="3" class="my-1" >-->


<!--                                                                  <b-badge v-if="issue.priority == 3"  pill class="text-right " size="sm" style="background-color: #212121;border: 1px solid #880e4f;float: right;font-size: 10px">اولویت زیاد</b-badge>-->
<!--                                                                  <b-badge v-else-if="issue.priority == 2"   pill class="text-right " size="sm" style="background-color: #757575;float: right;font-size: 10px">اولویت متوسط</b-badge>-->
<!--                                                                  <b-badge v-else-if="issue.priority == 1"  pill  class="text-right " size="sm" style="background-color: #9e9e9e;float: right;font-size: 10px">اولویت کم</b-badge>-->



<!--                                                              </b-col>-->

<!--                                                              <b-col  md="6" cols="5" class="my-1" >-->



<!--                                          <span v-if="issue.contact_id && issue.contact" :id="'tooltip-target-'+issue.id"-->
<!--                                                style="cursor: pointer" class="text-success  ml-2" >-->
<!--                                              <i class="fas fa-address-book"></i>-->
<!--                                          </span>-->
<!--                                                                  <b-tooltip   placement="bottom" v-if="issue.contact_id && issue.contact" :target="'tooltip-target-'+issue.id" triggers="hover">-->
<!--                                                                      <small>مشتری: </small>-->
<!--                                                                      {{issue.contact.last_name}}-->
<!--                                                                  </b-tooltip>-->






<!--                                                                  <span v-if="issue.project_id && issue.project" :id="'tooltip-target-project-'+issue.id"-->
<!--                                                                        style="cursor: pointer" class="text-info ml-2" >-->
<!--                                              <i class="fas fa-handshake"></i>-->
<!--                                          </span>-->
<!--                                                                  <b-tooltip  placement="bottom" v-if="issue.project_id && issue.project" :target="'tooltip-target-project-'+issue.id" triggers="hover">-->
<!--                                                                      <small>پروژه: </small>-->
<!--                                                                      {{issue.project.title}}-->
<!--                                                                  </b-tooltip>-->




<!--                                                                  <span v-for="(step, stepIconIndex) in steps" v-if="step.id === issue.step_id" :key="stepIconIndex" :id="'tooltip-target-step-'+issue.id"-->
<!--                                                                        style="cursor: pointer" class="text-dark ml-2" >-->
<!--                                              <i class="fas fa-random"></i>-->
<!--                                          </span>-->
<!--                                                                  <b-tooltip v-for="(step, stepTooltipIndex) in steps" v-if="step.id === issue.step_id"  :key="stepTooltipIndex"   placement="bottom"  :target="'tooltip-target-step-'+issue.id" triggers="hover">-->
<!--                                                                      <small>مرحله: </small>-->
<!--                                                                      {{step.title}}-->
<!--                                                                  </b-tooltip>-->





<!--                                                                  <span  :id="'tooltip-target-created-'+issue.id"-->
<!--                                                                         style="cursor: pointer" class="text-secondary  ml-2" >-->
<!--                                              <i class="fas fa-calendar"></i>-->
<!--                                          </span>-->
<!--                                                                  <b-tooltip   placement="bottom"  :target="'tooltip-target-created-'+issue.id" triggers="hover">-->
<!--                                                                      <small>تاریخ ثبت: </small>-->
<!--                                                                      {{issue.created_at| moment("dddd, jD jMMMM") }}-->
<!--                                                                  </b-tooltip>-->





<!--                                                              </b-col>-->

<!--                                                              <b-col  md="4" cols="4"  class="my-1 text-left text-sm"  >-->
<!--                                                                  &lt;!&ndash;                                          <small>&ndash;&gt;-->
<!--                                                                  &lt;!&ndash;                                              <b-col md="12" class="text-left text-sm">&ndash;&gt;-->
<!--                                                                  &lt;!&ndash;                                                  <small>&ndash;&gt;-->

<!--                                                                  &lt;!&ndash;                                                      <router-link  v-if="issue.contact_id && issue.contact" :title="issue.contact.first_name +' '+issue.contact.last_name" :to="{path: '/contact/profile/'+issue.contact_id, params: {id: issue.contact_id}}"&ndash;&gt;-->
<!--                                                                  &lt;!&ndash;                                                                   class="btn btn-success btn-sm" size="sm">&ndash;&gt;-->
<!--                                                                  &lt;!&ndash;                                                          مشتری:&ndash;&gt;-->

<!--                                                                  &lt;!&ndash;                                                          {{issue.contact.last_name}}&ndash;&gt;-->
<!--                                                                  &lt;!&ndash;                                                      </router-link>&ndash;&gt;-->

<!--                                                                  &lt;!&ndash;                                                  </small>&ndash;&gt;-->
<!--                                                                  &lt;!&ndash;                                              </b-col>                                          </small>&ndash;&gt;-->



<!--                                                                  &lt;!&ndash;                                          <b-badge  v-if="issue.contact_id && issue.contact" size="sm" variant="success"   class=" m-1" >&ndash;&gt;-->
<!--                                                                  &lt;!&ndash;                                              <small>مشتری: </small>&ndash;&gt;-->
<!--                                                                  &lt;!&ndash;                                              {{issue.contact.last_name}}</b-badge>&ndash;&gt;-->


<!--                                                                  &lt;!&ndash;                                          <b-badge v-if="issue.project" size="sm" variant="info"   class=" m-1">&ndash;&gt;-->
<!--                                                                  &lt;!&ndash;                                              <small>پروژه: </small>&ndash;&gt;-->
<!--                                                                  &lt;!&ndash;                                              {{issue.project.title}}</b-badge>&ndash;&gt;-->




<!--                                                                  &lt;!&ndash;                                          <span  v-for="(step, stepIndex) in steps" :key="stepIndex" >&ndash;&gt;-->
<!--                                                                  &lt;!&ndash;&lt;!&ndash;                                                     <i v-if="stepIndex != 0" class="fa fa-arrow-left"></i>&ndash;&gt;&ndash;&gt;-->
<!--                                                                  &lt;!&ndash;                                                    <b-badge  v-if="step.id === issue.step_id" variant="light">{{step.title}}</b-badge>&ndash;&gt;-->
<!--                                                                  &lt;!&ndash;                                              &lt;!&ndash;                                                    <b-badge v-else variant="secondary" style="opacity: 30%!important;">{{step.title}}</b-badge>&ndash;&gt;&ndash;&gt;-->
<!--                                                                  &lt;!&ndash;                                                </span>&ndash;&gt;-->





<!--                                                                  <small class="text-color-blue mt-1 mr-2" >-->

<!--                                                                      <span v-if="issue.type == 'lead'" class="badge badge-secondary pt-1" :style="{backgroundColor: typeBadgeStyles(issue)}">سرنخ/فرصت (Lead)</span>-->
<!--                                                                      <span v-if="issue.type == 'meeting'" class="badge badge-secondary pt-1" :style="{backgroundColor: typeBadgeStyles(issue)}">ملاقات/جلسه/رویداد</span>-->
<!--                                                                      <span v-if="issue.type == 'ticket'" class="badge badge-secondary pt-1" :style="{backgroundColor: typeBadgeStyles(issue)}">پیگیری (Ticket)</span>-->
<!--                                                                      <span v-if="issue.type == 'bug'" class="badge badge-danger pt-1" :style="{backgroundColor: typeBadgeStyles(issue)}">ایراد (Bug)</span>-->
<!--                                                                      <span v-if="issue.type == 'task'" class="badge badge-success pt-1" :style="{backgroundColor: typeBadgeStyles(issue)}">فعالیت (Task)</span>-->
<!--                                                                      <span v-if="issue.type == 'epic'" class="badge badge-info pt-1" :style="{backgroundColor: typeBadgeStyles(issue)}">نسخه/فیچر (Epic)</span>-->
<!--                                                                      <span v-if="issue.type == 'story'" class="badge badge-info pt-1" :style="{backgroundColor: typeBadgeStyles(issue)}">لیست (User Story)</span>-->


<!--                                                                  </small>-->
<!--                                                              </b-col>-->



                                                          </b-row>


                                                      </div>

                                                  </li>
<!--                                                  <li><div class="sticky">Mammals</div>-->
<!--                                                      <ul>-->

<!--                                                          &lt;!&ndash; Skill &ndash;&gt;-->
<!--                                                          <li><div>Elephant</div>-->
<!--                                                              <ul>-->

<!--                                                                  &lt;!&ndash; Attribute &ndash;&gt;-->
<!--                                                                  <li><div>List item 1</div></li>-->
<!--                                                                  <li><div>List item 2</div></li>-->
<!--                                                                  <li><div>List item 3</div></li>-->
<!--                                                                  <li><div>List item 4</div></li>-->
<!--                                                              </ul>-->
<!--                                                          </li>-->
<!--                                                          <li><div>Mouse</div>-->
<!--                                                              <ul>-->
<!--                                                                  <li><div>List item 1</div></li>-->
<!--                                                                  <li><div>List item 2</div></li>-->
<!--                                                              </ul>-->
<!--                                                          </li>-->
<!--                                                      </ul>-->
<!--                                                  </li>-->

                                              </ul>

                                          </li>

                                          <scroll-loader v-if="loadMore"  :loader-method="getMoreIssues" :loader-enable="loadMore">
                                          </scroll-loader>



                                      </ul>


                                  </div>













                             </b-col>
                          </b-row>

                      </b-col>





                  </b-row>


              </div>

          </CCol>





          <CCol md="3">

              <CCard class="p-4">

                  <div class="message-show text-right pt-3" >




                      <div
                              style="cursor: pointer" >
                          <div class="text-right margin-10 d-flex">
                              <!--                                        tagSearc
                                              var url = '/home/file/fileSearch/?input='+app.tagSearch
                              h-->

                              <div class="row text-right ">

                                  <div class="col-6 my-2">
                                      <small> از تاریخ ثبت:</small>
                                      <custom-time-picker
                                              v-model="search.created_at_from" @change="getIssues()"
                                              type="date" :clearable="true" placeholder="" min="" max=""
                                              size="sm" input-class="form-control form-control-sm">
                                      </custom-time-picker>
                                  </div>

                                  <div class="col-6 my-2">
                                      <small> تا تاریخ ثبت:</small>
                                      <custom-time-picker
                                              v-model="search.created_at_to" @change="getIssues()"
                                              type="date" :clearable="true" placeholder="" min="" max=""
                                              size="sm" input-class="form-control form-control-sm">
                                      </custom-time-picker>
                                  </div>


                                  <div class="col-6 my-2">
                                      <small> از تاریخ انجام:</small>
                                      <custom-time-picker
                                              v-model="search.done_date_from" @change="getIssues()"
                                              type="date" :clearable="true" placeholder="" min="" max=""
                                              size="sm" input-class="form-control form-control-sm">
                                      </custom-time-picker>
                                  </div>

                                  <div class="col-6 my-2">
                                      <small> تا تاریخ انجام:</small>
                                      <custom-time-picker
                                              v-model="search.done_date_to" @change="getIssues()"
                                              type="date" :clearable="true" placeholder="" min="" max=""
                                              size="sm" input-class="form-control form-control-sm">
                                      </custom-time-picker>
                                  </div>


<!--                                  <div class="col-12">-->
<!--                                      <label> برچسب:</label>-->

<!--&lt;!&ndash;                                      <b-form-input&ndash;&gt;-->
<!--&lt;!&ndash;                                              v-model="tagSearch"&ndash;&gt;-->
<!--&lt;!&ndash;                                              type="text"&ndash;&gt;-->
<!--&lt;!&ndash;                                              @keyup="getIssues()"&ndash;&gt;-->
<!--&lt;!&ndash;                                              size="sm"&ndash;&gt;-->
<!--&lt;!&ndash;                                              placeholder="برچسب (تگ)"&ndash;&gt;-->
<!--&lt;!&ndash;                                      ></b-form-input>&ndash;&gt;-->

<!--                                  </div>-->




                                  <div class="col-12 my-2">
                                      <small> موضوع:</small>
                                      <b-form-input v-model="search.title"
                                                    @keyup="getIssues()"
                                                    size="sm"
                                                    type="text"
                                                    placeholder="">
                                      </b-form-input>
                                  </div>




                                  <div class="col-12 my-2">
                                      <small>  نوع:</small>
                                      <b-form-select  size="sm" style="direction: ltr"
                                                      @change="getIssues()"
                                                      v-model="search.type"
                                                      type="text">
                                          <b-form-select-option  value="">
                                              همه
                                          </b-form-select-option>
                                          <b-form-select-option  value="lead" style="color: #f50057">سرنخ/فرصت (Lead)</b-form-select-option>
                                          <b-form-select-option  value="meeting" style="color: #8e24aa">ملاقات/جلسه/رویداد</b-form-select-option>
                                          <b-form-select-option  value="ticket" style="color: #263238" >پیگیری (Ticket)</b-form-select-option>
                                          <b-form-select-option  value="bug" style="color: #dd2c00">ایراد (Bug)</b-form-select-option>
                                          <b-form-select-option  value="task" style="color: #00c853">فعالیت (Task)</b-form-select-option>
                                          <b-form-select-option  value="story" style="color: #0097a7">لیست/شرح (Story)</b-form-select-option>
                                          <b-form-select-option  value="epic" style="color: #0288d1">مجموعه/امکانات (Epic)</b-form-select-option>
                                          <b-form-select-option  value="message" style="color: #0208ff">پیام/تلفن (Message)</b-form-select-option>
                                          <b-form-select-option  value="report" style="color: #888">گزارش/خبر (Report)</b-form-select-option>
                                          <b-form-select-option  value="etc" style="color: #888888">سایر</b-form-select-option>
                                      </b-form-select>
                                  </div>



                                  <div class="col-12 my-2">
                                      <small>  وضعیت انجام:</small>
                                      <b-form-select  size="sm" style="direction: ltr"
                                                      @change="getIssues()"
                                                      v-model="search.board_id"
                                                      type="text">
                                          <b-form-select-option  value="">همه</b-form-select-option>
                                          <b-form-select-option  value="1"  style="color: #ffab00">(Open) باز شده</b-form-select-option>
                                          <b-form-select-option  value="2"  style="color: #ffd600">(To DO) جهت انجام</b-form-select-option>
                                          <b-form-select-option  value="3"  style="color: #aeb130">درحال انجام (Doing)</b-form-select-option>
                                          <b-form-select-option  value="4"  style="color: #64dd17">جهت بازبینی (Review)</b-form-select-option>
                                          <b-form-select-option  value="5"  style="color: #00bfa5">انجام شده (Done)</b-form-select-option>
                                      </b-form-select>
                                  </div>

                                <div class="col-12 my-2">
                                      <small>  اولویت:</small>
                                      <b-form-select  size="sm" style="direction: ltr"
                                                      @change="getIssues()"
                                                      v-model="search.priority"
                                                      type="text">
                                          <b-form-select-option  value="">همه</b-form-select-option>
                                          <b-form-select-option  value="3" >  اولویت زیاد</b-form-select-option>
                                          <b-form-select-option  value="2" >  اولویت متوسط</b-form-select-option>
                                          <b-form-select-option  value="1" >  اولویت کم</b-form-select-option>
                                      </b-form-select>
                                  </div>


                                  <div class="col-12 my-2">
                                      <small> فرایند:</small>
                                      <b-form-select  size="sm" style="direction: ltr"
                                                      v-model="search.process_id" @change="getIssues()"
                                      >
<!--                                          getSteps($event) &&-->
                                          <b-form-select-option  value="">
                                              همه
                                          </b-form-select-option>
                                          <b-form-select-option  v-for="(process, processIndex) in processes" :key="processIndex"
                                                                 :value="process.id"  >
                                              {{process.title}}
                                          </b-form-select-option>

                                      </b-form-select>
                                  </div>

                                  <div class="col-12 my-2">
                                      <small> مرحله:</small>
                                      <b-form-select  size="sm" style="direction: ltr"
                                                      v-model="search.step_id" @change="getIssues()"
                                      >
                                          <b-form-select-option  value="">
                                              همه
                                          </b-form-select-option>
                                          <b-form-select-option  v-for="(step, stepIndex) in steps" :key="stepIndex"   :value="step.id" >
                                              {{step.title}}
                                          </b-form-select-option>



                                      </b-form-select>
                                  </div>







                                  <div class="col-12 my-2">
                                      <small> مشتری:</small>
                                      <v-select @change="getIssues()"
                                              v-model="search.contact_id"
                                              :options="contacts" label="last_name" :reduce="contact => contact.id" value="id">
                                      </v-select>


                                      <!--                            <multiselect  v-model="contact_id"  @select="setContactId()"    :options="contactOptions" :custom-label="customLabel"-->
                                      <!--                                         placeholder=" انتخاب مشتری" label="title" track-by="title">-->
                                      <!--                            </multiselect>-->
                                  </div>

                                  <div class="col-12 my-2">
                                      <small>پروژه:</small>

                                      <v-select @change="getIssues()"
                                              v-model="search.project_id"
                                              :options="projects" label="title" :reduce="project => project.id" value="id">
                                      </v-select>

                                  </div>





<!--                                  <div class="col-12 my-2">-->
<!--                                      <small> {{$client}}:</small>-->
<!--                                      <b-form-select  size="sm" style="direction: ltr"-->
<!--                                                      v-model="search.contact_id" @change="getIssues()"-->
<!--                                      >-->
<!--                                          <b-form-select-option  value="">-->
<!--                                              همه-->
<!--                                          </b-form-select-option>-->

<!--                                          <b-form-select-option  v-for="(contact, contactIndex) in contacts" :key="contactIndex"   :value="contact.id" >-->
<!--                                              {{contact.last_name}}-->
<!--                                          </b-form-select-option>-->


<!--                                      </b-form-select>-->
<!--                                  </div>-->

<!--                                  <div class="col-12 my-2">-->
<!--                                      <small> پروژه:</small>-->
<!--                                      <b-form-select  size="sm" style="direction: ltr"-->
<!--                                      >-->
<!--                                          <b-form-select-option  value="">-->
<!--                                              همه-->
<!--                                          </b-form-select-option>-->


<!--                                      </b-form-select>-->
<!--                                  </div>-->
                                  <div class="col-12 mt-3">
                                      <button @click="getIssues()" class="btn btn-success">فیلتر</button>
                                  </div>


                              </div>




                              <!--                                  <multiselect  v-model="newPost.fileLib_tags" :height="300" :options="options" :multiple="true"-->
                              <!--                                                                  :taggable="true" :close-on-select="false" :clear-on-select="false"-->
                              <!--                                                                  :custom-label="customLabel"-->
                              <!--                                                                  :preserve-search="true" :hide-selected="true" :show-labels="false"-->
                              <!--                                                                  tag-placeholder="افزودن تگ جدید" placeholder="برچست (تگ)"-->
                              <!--                                                                  label="title" track-by="title" :preselect-first="false"-->

                              <!--                                                                  @tag="addTag">-->
                              <!--                                                        &lt;!&ndash; <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single"-->
                              <!--                                        v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options selected</span></template> &ndash;&gt;-->
                              <!--                                        </multiselect>-->
                          </div>
                      </div>







                  </div>

              </CCard>

<!--              <CCard class="p-4">-->


<!--                  <b-row class="ml-1">-->
<!--                      &lt;!&ndash;                              <b-col md=12 class="text-right my-2">&ndash;&gt;-->
<!--                      &lt;!&ndash;                                  <router-link :to="{path : '/social/course/intro'}">&ndash;&gt;-->
<!--                      &lt;!&ndash;                                      <div class="bg-blue p-3">&ndash;&gt;-->
<!--                      &lt;!&ndash;                                          <h4 class="text-white my-2 mb-2 h5">   sayan</h4>&ndash;&gt;-->
<!--                      &lt;!&ndash;                                          <small class="text-white">&ndash;&gt;-->
<!--                      &lt;!&ndash;                                              </small>&ndash;&gt;-->
<!--                      &lt;!&ndash;                                          &lt;!&ndash;                                <p class="m-0">&ndash;&gt;&ndash;&gt;-->
<!--                      &lt;!&ndash;                                          &lt;!&ndash;                                    <b-img-lazy src="/image/avatars.png" alt="Image 3" class="float-left tree-circle">&ndash;&gt;&ndash;&gt;-->
<!--                      &lt;!&ndash;                                          &lt;!&ndash;                                    </b-img-lazy> <i class="fas fa-check-circle color-check"></i>&ndash;&gt;&ndash;&gt;-->
<!--                      &lt;!&ndash;                                          &lt;!&ndash;                                </p>&ndash;&gt;&ndash;&gt;-->
<!--                      &lt;!&ndash;                                      </div>&ndash;&gt;-->
<!--                      &lt;!&ndash;                                  </router-link>&ndash;&gt;-->
<!--                      &lt;!&ndash;                              </b-col>&ndash;&gt;-->
<!--                      &lt;!&ndash;                              <b-col md=12 class="text-right my-2">&ndash;&gt;-->
<!--                      &lt;!&ndash;                                  <router-link :to="{path : '/social/forum/intro'}">&ndash;&gt;-->
<!--                      &lt;!&ndash;                                      <div class="bg-blue-light p-3">&ndash;&gt;-->
<!--                      &lt;!&ndash;                                          <h4 class="text-white my-2 mb-2 h5">  sayan</h4>&ndash;&gt;-->
<!--                      &lt;!&ndash;                                          <small class="text-white"></small>&ndash;&gt;-->
<!--                      &lt;!&ndash;                                      </div>&ndash;&gt;-->
<!--                      &lt;!&ndash;                                  </router-link>&ndash;&gt;-->
<!--                      &lt;!&ndash;                              </b-col>&ndash;&gt;-->












<!--                      <CCol md="12" sm="12" class="mb-sm-12 mb-3">-->
<!--                          <div class="text-muted">پیگیری ها (Tickets)</div>-->
<!--                          <small style="color: #b0bec5">33 از 44 انجام شده (60%)</small>-->
<!--                          <CProgress-->
<!--                                  class="progress-xs mt-2"-->
<!--                                  :precision="1"-->
<!--                                  color="warning"-->
<!--                                  :value="60"-->
<!--                          />-->
<!--                      </CCol>-->
<!--                      <CCol md="12" sm="12" class="mb-sm-12 mb-3">-->
<!--                          <div class="text-muted">سرنخ/فرصت های {{$sale}} </div>-->
<!--                          <small style="color: #b0bec5">33 از 84 پیگیری شده (80%)</small>-->
<!--                          <CProgress-->
<!--                                  class="progress-xs mt-2"-->
<!--                                  :precision="1"-->
<!--                                  color="danger"-->
<!--                                  :value="80"-->
<!--                          />-->
<!--                      </CCol>-->


<!--                      <CCol md="12" sm="12" class="mb-sm-12 mb-3 d-none">-->
<!--                          <div class="text-muted">ایراد ها (Bugs) </div>-->
<!--                          <small style="color: #b0bec5">73 از 84 رفع شده (80%)</small>-->
<!--                          <CProgress-->
<!--                                  class="progress-xs mt-2"-->
<!--                                  :precision="1"-->
<!--                                  color="danger"-->
<!--                                  :value="80"-->
<!--                          />-->
<!--                      </CCol>-->


<!--                      <CCol md="12" sm="12" class="mb-sm-12 mb-3 d-md-down-none">-->
<!--                          <div class="text-muted">فعالیت ها (Tasks) </div>-->
<!--                          <small style="color: #b0bec5">11 از 22 انجام شده (50%)</small>-->
<!--                          <CProgress-->
<!--                                  class="progress-xs mt-2"-->
<!--                                  :precision="1"-->
<!--                                  :value="40"-->
<!--                          />-->
<!--                      </CCol>-->
<!--                      <CCol md="12" sm="12" class="mb-sm-12 mb-3">-->
<!--                          <div class="text-muted">ملاقات ها / جلسات</div>-->
<!--                          <small style="color: #b0bec5">22 از 44 برگزار شده (50%)</small>-->
<!--                          <CProgress-->
<!--                                  class="progress-xs mt-2"-->
<!--                                  :precision="1"-->
<!--                                  color="success"-->
<!--                                  :value="40"-->
<!--                          />-->
<!--                      </CCol>-->



<!--                      <CCol md="12" sm="12" class="mb-sm-12 mb-3 d-md-down-none">-->
<!--                          <div class="text-muted">Epics / User Stories</div>-->
<!--                          <small style="color: #b0bec5">6 از 21 تمام شده (34%)</small>-->
<!--                          <CProgress-->
<!--                                  class="progress-xs mt-2"-->
<!--                                  :precision="1"-->
<!--                                  color="info"-->
<!--                                  :value="20"-->
<!--                          />-->
<!--                      </CCol>-->




<!--                  </b-row>-->
<!--              </CCard>-->
          </CCol>


<!--          <BootstrapTable :columns="columns" :data="data" :options="tableOptions"></BootstrapTable>-->



      </CRow>










  </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import MainChartExample from './charts/MainChartExample'
import WidgetsDropdown from './widgets/WidgetsDropdown'
import WidgetsBrand from './widgets/WidgetsBrand'

import BootstrapTable from 'bootstrap-table'

import { CChartLineSimple, CChartBarSimple } from './charts/index'

import Multiselect from 'vue-multiselect'

import addIssue from './issue/add'
import issueItemShow from './issue/item'

export default {
  name: 'Dashboard',
  components: {
    MainChartExample,
    WidgetsDropdown,
    WidgetsBrand,
      CChartLineSimple,
      CChartBarSimple,

      Multiselect,

      addIssue,
      issueItemShow,

      BootstrapTable




  },
  data () {
    return {
      selected: 'Month',
      tableItems: [
        {
          avatar: { url: 'img/avatars/1.jpg', status: 'success' },
          user: { name: 'Yiorgos Avraamu', new: true, registered: 'Jan 1, 2015' },
          country: { name: 'USA', flag: 'cif-us' },
          usage: { value: 50, period: 'Jun 11, 2015 - Jul 10, 2015' },
          payment: { name: 'Mastercard', icon: 'cib-cc-mastercard' },
          activity: '10 sec ago'
        },
        {
          avatar: { url: 'img/avatars/2.jpg', status: 'danger' },
          user: { name: 'Avram Tarasios', new: false, registered: 'Jan 1, 2015' },
          country: { name: 'Brazil', flag: 'cif-br' },
          usage: { value: 22, period: 'Jun 11, 2015 - Jul 10, 2015' },
          payment: { name: 'Visa', icon: 'cib-cc-visa' },
          activity: '5 minutes ago'
        },
        {
          avatar: { url: 'img/avatars/3.jpg', status: 'warning' },
          user: { name: 'Quintin Ed', new: true, registered: 'Jan 1, 2015' },
          country: { name: 'India', flag: 'cif-in' },
          usage: { value: 74, period: 'Jun 11, 2015 - Jul 10, 2015' },
          payment: { name: 'Stripe', icon: 'cib-stripe' },
          activity: '1 hour ago'
        },
        {
          avatar: { url: 'img/avatars/4.jpg', status: '' },
          user: { name: 'Enéas Kwadwo', new: true, registered: 'Jan 1, 2015' },
          country: { name: 'France', flag: 'cif-fr' },
          usage: { value: 98, period: 'Jun 11, 2015 - Jul 10, 2015' },
          payment: { name: 'PayPal', icon: 'cib-paypal' },
          activity: 'Last month'
        },
        {
          avatar: { url: 'img/avatars/5.jpg', status: 'success' },
          user: { name: 'Agapetus Tadeáš', new: true, registered: 'Jan 1, 2015' },
          country: { name: 'Spain', flag: 'cif-es' },
          usage: { value: 22, period: 'Jun 11, 2015 - Jul 10, 2015' },
          payment: { name: 'Google Wallet', icon: 'cib-google-pay' },
          activity: 'Last week'
        },
        {
          avatar: { url: 'img/avatars/6.jpg', status: 'danger' },
          user: { name: 'Friderik Dávid', new: true, registered: 'Jan 1, 2015' },
          country: { name: 'Poland', flag: 'cif-pl' },
          usage: { value: 43, period: 'Jun 11, 2015 - Jul 10, 2015' },
          payment: { name: 'Amex', icon: 'cib-cc-amex' },
          activity: 'Last week'
        }
      ],
      tableFields: [
        { key: 'avatar', label: '', _classes: 'text-center' },
        { key: 'user' },
        { key: 'country', _classes: 'text-center' },
        { key: 'usage' },
        { key: 'payment', label: 'Payment method', _classes: 'text-center' },
        { key: 'activity' },
      ],





        auth: {
            headers: {
                Authorization: 'bearer ' + localStorage.getItem('token')
            }
        },

        role: localStorage.getItem('role'),
        authUser:
            {
                id:localStorage.getItem('id'),
            },



        loadMore: true,
        page: 1,
        pageSize: 10,
        voice: '',

        courseCategories:[],
        fileCategories:[],
        forumCategories:[],
        forums:[],


        issues:[],
        issueText: 0,


        rules: [v => v.length <= 300 || 'تعداد حروف بیشتر از 300 کاراکتر است!'],

        showVoiceRecorder: false,
        showFileUploader: false,
        showImageUploader: false,
        showVideoUploader: false,

        src: null,
        srcPlay: null,

        issueAsCourse: false,
        issueAsForum: false,

        courseDisabled: false,
        forumDisabled: false,

        newComment:'',
        newReply:'',

        options:[],

        selectedTags: [],
        tags: [],
        isLoading: false,




        typeOptions: [
            { value: 'ticket', text: 'پیگیری (Ticket)' , selected :true},
            { value: 'bug', text: 'ایراد (Bug)' },
            { value: 'task', text: 'فعالیت (Task)' },
            { value: 'story', text: 'لیست (Story)' },
            { value: 'epic', text: 'نسخه/فیچر (Epic)' },
            { value: 'lead', text: 'سرنخ/فرصت (Lead)' },
            { value: 'meeting', text: 'ملاقات/جلسه/رویداد' },

        ],



        warningModal: false,


        search: {

                title: '',
                description: '',
                type: '',
                project_id: '',
                section_id: '',
                process_id: '',
                step_id: '',
                board_id: '',

                created_at_from: '',
                created_at_to: '',
                due_date: '',
                start_date: '',
                done_date_from: '',
                done_date_to: '',
                close_date: '',

                priority: '',
                contact_id: '',
                order_id: '',
                person_id: '',
                created_by: '',
                updated_by: '',
        },


        contact_id: '',




        addIssue: {
            parent_id: null,
            reply_id: null,
            sprint_id: null,
            board_id: null,
            process_id: null,
            section_id: null,
            step_id: null
        },

        processes: [],
        steps: [],
        orders: [],
        contacts: [],
        projects: [],











        columns: [
            {
                title: 'Item ID',
                field: 'id'
            },
            {
                field: 'name',
                title: 'Item Name'
            }, {
                field: 'price',
                title: 'Item Price'
            }
        ],
        data: [
            {
                id: 1,
                name: 'Item 1',
                price: '$1'
            }
        ],
        tableOptions: {
            search: true,
            showColumns: true
        }




    }
  },


    watch: {


        search: {
            deep: true,
            handler() {

                this.getSteps(this.search.process_id)

            }
        }



        },



    beforeRouteUpdate(to, from, next) {
        // this.getProcesses()
        // this.getSteps()
        // this.getProjects()
        // this.getOrders()
        // this.getContacts()
        // this.getUsers()
    },


    mounted() {



        //
        // this.getCourseCategories()
        // this.getFileCategories()
        // this.getForumCategories()
        // this.getForums()
        //


        this.getProcesses()
        this.getSteps()
        this.getProjects()
        this.getOrders()
        this.getContacts()
        // this.getUsers()




    },



    methods: {
    color (value) {
      let $color
      if (value <= 25) {
        $color = 'info'
      } else if (value > 25 && value <= 50) {
        $color = 'success'
      } else if (value > 50 && value <= 75) {
        $color = 'warning'
      } else if (value > 75 && value <= 100) {
        $color = 'danger'
      }
      return $color
    },








        getIssues(){
            var app = this;

            axios.get('/api/intro/index' +
                '?title='+app.search.title+
                '&description='+app.search.description+
                '&type='+app.search.type+
                '&project_id='+app.search.project_id+
                '&section_id='+app.search.section_id+

                '&process_id='+app.search.process_id+
                '&step_id='+app.search.step_id+
                '&board_id='+app.search.board_id+

                '&created_at_from='+app.search.created_at_from+
                '&created_at='+app.search.created_at_to+
                '&created_at_to='+app.search.due_date+
                '&start_date='+app.search.start_date+
                '&done_date_from='+app.search.done_date_from+
                '&done_date_to='+app.search.done_date_to+
                '&close_date='+app.search.close_date+

                '&priority='+app.search.priority+
                '&contact_id='+app.search.contact_id+
                '&order_id='+app.search.order_id+
                '&person_id='+app.search.person_id+
                '&created_by='+app.search.created_by+
                '&updated_by='+app.search.updated_by
                , app.auth)
                .then(function (response) {
                    app.issues = response.data.data
                    // console.log(response.data);
                })
                .catch(function (e) {
                    console.log(e.response);
                });
        },

        getMoreIssues(){
            var app = this;



            if(app.loadMore == true){

                axios.get('/api/intro/index' +
                    '?title='+app.search.title+
                    '&description='+app.search.description+
                    '&type='+app.search.type+
                    '&project_id='+app.search.project_id+
                    '&section_id='+app.search.section_id+

                    '&process_id='+app.search.process_id+
                    '&step_id='+app.search.step_id+
                    '&board_id='+app.search.board_id+

                    '&created_at_from='+app.search.created_at_from+
                    '&created_at='+app.search.created_at_to+
                    '&created_at_to='+app.search.due_date+
                    '&start_date='+app.search.start_date+
                    '&done_date_from='+app.search.done_date_from+
                    '&done_date_to='+app.search.done_date_to+
                    '&close_date='+app.search.close_date+

                    '&priority='+app.search.priority+
                    '&contact_id='+app.search.contact_id+
                    '&order_id='+app.search.order_id+
                    '&person_id='+app.search.person_id+
                    '&created_by='+app.search.created_by+
                    '&updated_by='+app.search.updated_by+
                '&page='+app.page , app.auth)
                    .then(res => {
                        // app.issues.concat(res.data.data)
                        res.data.data.forEach(
                            (val)=>{ app.issues.push(val)});

                        app.page++

//                        if(res.data.data.lenght == null)
//                            app.endMore = true

                        // Stop scroll-loader
                        res.data.data.length < app.pageSize && (app.loadMore = false)
                    })
                    .catch(error => {
                        console.log(error);
                    })

            }


        },


        bottomVisible() {
            const scrollY = window.scrollY
            const visible = document.documentElement.clientHeight
            const pageHeight = document.documentElement.scrollHeight
            const bottomOfPage = visible + scrollY >= pageHeight
            return bottomOfPage || pageHeight < visible
        },

        pluck(array, key) {
            return array.map(function (obj) {
                return obj[key];
            });
        },



        onResult (data) {
//                console.log('The blob data:', data);
//                console.log('Downloadable audio', window.URL.createObjectURL(data));
            this.srcPlay =  window.URL.createObjectURL(data)
            this.src =  data

        },

        headerStyles(issue){
            if (issue.type == 1)
                return '2px solid #a01c7d'
            else if (issue.type == 'ticket')
                return '2px solid #263238'
            else if (issue.type == 'bug')
                return '2px solid #ff2c00'
            else if (issue.type == 'task')
                return '2px solid #00e853'
            else if (issue.type == 'story')
                return '2px solid #0097a7'
            else if (issue.type == 'epic')
                return '2px solid #0288ff'
            else if (issue.type == 'lead')
                return '2px solid #950057'
            else if (issue.type == 'meeting')
                return '2px solid #8e24aa'
            else if (issue.type == 'event')
                return '2px solid #eeb600'
            else if (issue.type == 'message')
                return '2px solid #0208ff'
            else if (issue.type == 'report')
                return '2px solid #888'
            else
                return '2px solid #999999'
        },


        boardColor(boardID){
            if (boardID == 1)
                return '#ee6600'
            else if (boardID == 2)
                return '#ffd600'
            else if (boardID == 3)
                return '#aeb130'
            else if (boardID == 4)
                return '#64dd17'
            else if (boardID == 5)
                return '#0097a7'
            else if (boardID == 6)
                return '#00bfa5'
            else
                return ''
        },

        typeBadgeStyles(issue){
            if (issue.type == 1)
                return '#a01c7d'
            else if (issue.type == 'ticket')
                return '#263238'
            else if (issue.type == 'bug')
                return '#ff2c00'
            else if (issue.type == 'task')
                return '#00e853'
            else if (issue.type == 'story')
                return '#0097a7'
            else if (issue.type == 'epic')
                return '#0288ff'
            else if (issue.type == 'lead')
                return '#950057'
            else if (issue.type == 'meeting')
                return '#8e24aa'
            else if (issue.type == 'event')
                return '#eeb600'
            else
                return '#999999'
        },


        customLabel(option) {
            //   console.log(option.title)

            //   this.item.tags.push(option)
            return `${option.title}`

        },


        ajaxFindTag(query){

        },


        limitText (count) {
            return `and ${count} other tags`
        },
        asyncFind (query) {
            this.isLoading = true
            this.ajaxFindTag(query).then(response => {
                this.tags = response
                this.isLoading = false
            })
        },
        clearAll () {
            this.selectedTags = []
        },



        getProcesses(){
            var app = this;
            axios.get('/api/intro/processes', app.auth)
                .then(function (response) {
                    app.processes = response.data.data.data
                })
                .catch(function (e) {
                    console.log(e.response);
                });
        },

        getSteps(processID = null){
            var app = this;
            axios.get('/api/intro/steps/'+processID ,  app.auth)
                .then(function (response) {
                    app.steps = response.data.data.data
                })
                .catch(function (e) {
                    console.log(e.response);
                });
        },

        getOrders(){

            axios.get('/api/orders', this.auth)
                .then(response => {
                    // this.current_page = response.data.current_page
                    this.orders = response.data.data;
                    console.log(response.data.data)
                    // this.pagnationDate = response.data
                    // console.log(this.pagnationDate)
                    // this.loader = false
                })
                .catch(error => {
                    // this.loader = false
                    console.log(error);
                })
        },

        getContacts(){

            axios.get('/api/contacts', this.auth)
                .then(response => {
                    // this.current_page = response.data.current_page
                    this.contacts = response.data.data;
                    console.log(response.data.data)
                    // this.pagnationDate = response.data
                    // console.log(this.pagnationDate)
                    // this.loader = false

                    // this.makeContactOptions()

                })
                .catch(error => {
                    // this.loader = false
                    console.log(error);
                })
        },
        // makeContactOptions(){
        //     var app = this;
        //
        //     for (const key in app.contacts) {
        //         if (app.contacts.hasOwnProperty(key)) {
        //             const element = app.contacts[key];
        //
        //             app.contactOptions.push({
        //                 value: element.id,
        //                 text: element.first_name+' '+element.last_name
        //             })
        //             // this.details[0].
        //         }
        //     }
        //     console.log(app.contacts)
        //     console.log(app.contactOptions)
        //
        //
        // },
        getProjects() {
            axios
                .get('/api/projects', this.auth)
                .then(response => {
                    console.log('projects',response.data.data);

                    this.projects = response.data.data;
                })
                .catch(error => {
                    console.log(error);
                    this.errored = true
                })
        },






    }
}
</script>











<style scoped>


    tr{
        box-shadow: 0px 4px 4px rgba(0,0,0,.15);

    }






    .tree ul {
        margin: 0 0 0 15em;
        padding: 0;
        list-style: none;
        /*color: #369;*/
        position: relative;
    }
    .tree:before, .tree ul:before {
        content: "";
        display: block;
        width: 0px;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 202px;
        border-left: 1px solid;
        /*background: white;*/
        /*z-index: -1;*/
    }
    .tree li {
        font-weight: bold;
        line-height: 3em;
        margin: 0;
        padding: 1.5em 0 0 2em;
        position: relative;
    }
    .tree li:before {
        border-top: 1px solid;
        content: "";
        display: block;
        height: 100%;
        left: 400px;
        margin-top: 1em;
        position: absolute;
        top: 1.5em;
        width: 20em;


    }
    .tree li:last-child:before {
        /*background: white;*/
        bottom: 0;
        height: auto;
        top: 1.5em;
    }
    .tree > li:before {
        border-top: none !important;
    }
    .tree li div {
        border-radius: 5px;
        /*border: 1px solid #afafaf;*/
        margin: 0;
        max-width: 20em;
        min-width: 15em;
        /*padding: 0.25em 0.5em;*/
        /*background: white;*/
        /*box-shadow: 1px 1px 4px #8F949A;*/
        /*color: #369;*/
        /*font-weight: bold;*/
        overflow: hidden;
    }

    ul.tree {
        margin-right: 0px;
    }
    ul.tree:before {
        border-right: none;
    }

    .sticky {
        position: -webkit-sticky;
        position: sticky;
        top: 0px;
        width: 100%;
    }

</style>
